document.documentElement.classList.remove('no-js');

(() => {
  const entrance = document.getElementById('ViiEntrance');
  const enterButton = document.getElementById('ViiEnterButton');

  if (entrance && entrance.dataset.sessionOnly === 'true' && sessionStorage.getItem('vii-entered') === 'true') {
    entrance.remove();
  } else if (entrance && enterButton) {
    document.body.style.overflow = 'hidden';
    enterButton.addEventListener('click', () => {
      entrance.classList.add('is-leaving');
      document.body.style.overflow = '';
      sessionStorage.setItem('vii-entered', 'true');
      window.setTimeout(() => entrance.remove(), 850);
    });
  }

  const menu = document.getElementById('ViiMobileMenu');
  const openButton = document.querySelector('[data-vii-menu-toggle]');
  const closeButton = document.querySelector('[data-vii-menu-close]');
  const closeMenu = () => {
    if (!menu || !openButton) return;
    menu.hidden = true;
    openButton.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };
  if (menu && openButton) {
    openButton.addEventListener('click', () => {
      menu.hidden = false;
      openButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      closeButton?.focus();
    });
    closeButton?.addEventListener('click', closeMenu);
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) closeMenu();
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    if (!select || !price) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (option?.dataset.price) price.textContent = option.dataset.price;
    });
  });
})();
